// 009 FR-045: the confirmation after a paid checkout.
import { ConfirmationScreen } from "@/checkout/ConfirmationScreen";

export default function OrderPlaced() {
  return <ConfirmationScreen />;
}
